import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";
import { MaskedLine, Reveal, Overline } from "../components/Kinetic";
import { TWO_A_URL, EvalNote } from "../components/EstimateCTA";
import { Seo, SITE } from "../components/Seo";

export default function InfoPage({ page, slug }) {
  return (
    <main data-testid={`info-page-${slug}`}>
      <Seo title={page.metaTitle} description={page.metaDescription} path={`/${slug}`}
        jsonLd={[{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: SITE },
            { "@type": "ListItem", position: 2, name: page.title, item: `${SITE}/${slug}` },
          ],
        }]} />

      <section className="pt-32 md:pt-44">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Overline>{page.overline}</Overline>
          <h1 className="mt-6 max-w-4xl font-display text-4xl font-extrabold leading-[1.0] tracking-tighter sm:text-5xl lg:text-6xl">
            <MaskedLine delay={0.15}>{page.title}</MaskedLine>
          </h1>
          <Reveal delay={0.35}>
            <p className="mt-7 max-w-2xl text-lg leading-relaxed text-[#4A4A4A]">{page.intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-6 md:px-12">
          {page.sections.map((s, i) => (
            <Reveal key={s.heading} delay={0.05}>
              <div className="border-t border-black/10 py-12 first:border-t-0 first:pt-0" data-testid={`info-section-${i}`}>
                <h2 className="font-display text-2xl font-bold tracking-tight text-black md:text-3xl">{s.heading}</h2>
                {s.paragraphs.map((p, j) => (
                  <p key={j} className="mt-5 text-base leading-[1.85] text-[#2a2a2a] md:text-[1.0625rem]">{p}</p>
                ))}
                {s.links && (
                  <div className="mt-6 flex flex-wrap gap-3">
                    {s.links.map((l) => (
                      <Link key={l.to} to={l.to} data-testid={`info-link-${l.to.split("/").pop()}`}
                        className="group inline-flex items-center gap-2 rounded-full border border-brand/30 bg-brand/[0.04] px-5 py-2.5 text-sm font-semibold text-brand transition-colors hover:bg-brand hover:text-white">
                        {l.label}
                        <ArrowUpRight size={14} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-navy py-20 text-center">
        <Reveal>
          <h2 className="mx-auto max-w-2xl px-6 font-display text-3xl font-extrabold tracking-tighter text-white md:text-5xl">
            Ready when your device is.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <a href={TWO_A_URL} target="_blank" rel="noopener" data-testid={`${slug}-estimate-btn`}
            className="group mt-9 inline-flex items-center gap-2 rounded-full bg-white px-10 py-5 font-display text-sm font-bold uppercase tracking-[0.12em] text-navy transition-colors duration-300 hover:bg-brand hover:text-white">
            Get a Buyback Estimate
            <ArrowRight size={16} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <div className="mt-4 flex justify-center"><EvalNote light /></div>
        </Reveal>
      </section>
    </main>
  );
}
